
export function maskQuestionnaire(questionnaire, config) {
  let masked_sections = fromConfig(config)

  return questionnaire.filter(
    (section, index) => masked_sections[index]
  )
}

export function toConfig(show_sections_array) {
  return show_sections_array.reduce( (a, b) => a + Number(Boolean(b)), "" )
}

export function fromConfig(config) {
  let values = config.split("")
  return values.map( e => Boolean(Number(e)) )
}

export function exportAnswerObject(questionnaire, prefix) {
  let answers = {}
  questionnaire.forEach((el, i) => {
    el.questions.forEach((q, j) => {
      answers[prefix + '_' + i + '_' + (j+1)] = q.a
    })
  })
  return answers
}

export function computeScores(questionnaire) {
  return questionnaire.map(s => s.questions
    .map(q => q.a)
    .reduce( (a, b) => Number(a) + Number(b) )
  )
}

export function scoresToString(scores) {
  return scores.join(";")
}

export function stringToScores(string) {
  let strings = string.split(";")
  return strings.map(s => s === "" ? null : Number(s))
}

export function computeResultId(config, scores) {
  let masked_sections = fromConfig(config)

  for (let i = 0; i < masked_sections.length; i++) {
    if (masked_sections[i]) continue
    scores.splice(i, 1, null) // replace element
  }

  return scoresToString(scores)
}

export function attachScores(questionnaire, results) {
  let scores = stringToScores(results);
  let config = toConfig(scores.map(e => e))

  questionnaire.forEach((s, i) => s.score = scores[i])

  let masked_questionnaire = maskQuestionnaire(questionnaire, config)

  let totals = masked_questionnaire
    .map(section => section.questions)
    .map(
      section => section
        .map(q => Math.max(...q.s))
        .reduce((a,b) => a+b)
    )

  masked_questionnaire.map((s, i) => s.tot = totals[i])
  masked_questionnaire.map(s => s.pct = Math.round((s.score / s.tot) * 100))

  return masked_questionnaire
}
